function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.6 6.5V5.9H16H7.49481C7.2747 5.9 7.09596 5.72218 7.09481 5.50208L7.08179 3.00208C7.08064 2.78036 7.26006 2.6 7.48178 2.6H19.3896C19.6105 2.6 19.7896 2.77909 19.7896 3V17.5168C19.7896 17.7385 19.6093 17.9179 19.3876 17.9168L16.998 17.9049C16.7779 17.9038 16.6 17.7251 16.6 17.5049V6.5Z",
  stroke: "#556677",
  strokeWidth: 1.2
});
var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-1_10554_10312",
  fill: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 5.47827,
  width: 13.913,
  height: 16.5217,
  rx: 1
}));
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 5.47827,
  width: 13.913,
  height: 16.5217,
  rx: 1,
  stroke: "#556677",
  strokeWidth: 2.4,
  mask: "url(#path-2-inside-1_10554_10312)"
});
var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 6.20938,
  y1: 9.22617,
  x2: 13.705,
  y2: 9.22617,
  stroke: "#556677",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 6.20938,
  y1: 15.3131,
  x2: 13.705,
  y2: 15.3131,
  stroke: "#556677",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.26172 12.1274H13.653",
  stroke: "#556677",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 6.20938,
  y1: 18.7914,
  x2: 13.705,
  y2: 18.7914,
  stroke: "#556677",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});
const SvgContractsIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContractsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contracts-icon.47f64d7d.svg";
export { ForwardRef as ReactComponent };